
import { useState, useEffect } from "react";
import axiosConfig from '../axiosConfig';
import Header from "../Header/Header";
import MainMenu from "../MainMenu/MainMenu";
import { useParams } from "react-router-dom";




const DeviceHistoryLog = () => {
    const { id } = useParams();

    const [device, setDevice] = useState([]);
    const [deviceBoxHistoryLogs, setDeviceBoxHistoryLogs] = useState([]);

    const [query, setQuery] = useState("");
    useEffect(() => {
        axiosConfig.get("/device/box/history/"+ id).then((rsp) => {
            setDevice(rsp.data.device);
            setDeviceBoxHistoryLogs(rsp.data.device_box_history_logs);
            //console.log(rsp.data);
        }, (err) => { });


    }, []);


    const Search = (data) => {
        return data.filter(
            (item) =>
                item.box_id && item.box_id.toString().includes(query)
        );
    };



    
    



    return (
        <div><Header title="Household Device History Log" />
            <MainMenu menu="device" />
            <div class="app-content content">
                <div class="content-overlay"></div>
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >
                    <div class="content-header row">
                    </div>
                    <div class="content-body">



                        <div class="row justify-content-md-center">
                            <div class="col-xl-12  col-12">
                                <section id="horizontal-vertical">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card">

                                                <div class="card-content collapse show">
                                                    <div class="card-body card-dashboard">

                                                        <div class="row">
                                                            <div class="col-md-7"><div class="h3 font-weight-bold">{ device.device_name} - Box History Log</div></div>
                                                            <div class="col-md-5"><input type="text" class="search form-control round border-primary mb-1" placeholder="Search by Device Name or Box ID" onChange={e => setQuery(e.target.value)} />
                                                            </div>

                                                        </div>
                                                        {/* <a class="btn btn-primary" href="/device/create">Create New</a> */}
                                                        {/* <button class="btn btn-success pull-right" onClick={exportDevices}>Export</button> */}
                                                        <div class="table-responsive" style={{ maxHeight: '400px', minHeight: '500px' }}>
                                                            {
                                                                deviceBoxHistoryLogs.length > 0 ? 
                                                                    <table class="table display nowrap table-striped table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Box ID</th>
                                                                            <th>Assigned At</th>
                                                                            <th>Assigned by</th>
                                                                            <th>Disconnected At</th>
                                                                            <th>Disconnected by</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {Search(deviceBoxHistoryLogs).map((deviceHistory) =>
                                                                            <tr key={deviceHistory.id}>
                                                                                <td>{deviceHistory.box_id}</td>
                                                                                <td>{deviceHistory.connected_at}</td>
                                                                                <td>{deviceHistory.connected_by !== null && <span class="">{deviceHistory.connected_by_user.user_name}</span>}</td>
                                                                                <td>{deviceHistory.disconnected_at !== null ? <span class="">{deviceHistory.disconnected_at}</span> : <span class="text-success">Stil Connected</span>}</td>
                                                                                <td>{deviceHistory.disconnected_by !== null ? <span class="">{deviceHistory.disconnected_by_user.user_name}</span> : 'Not Available'}</td>

                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                                : <div class="h3 font-weight-bold text-center">No Log Found</div>
                                                            }
                                                            
                  
                                                            
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section >





                            </div>
                        </div>


                        <br />



                        <br />


                    </div>
                </div>

            </div>
        </div>
    )

}
export default DeviceHistoryLog;